const IndexPage = () => {
  return null;
};

export default IndexPage;
